class Automation {
    folio;
    invoiceDate;
    name;
    rfc;
    unitCode;
    quantity;
    productCode;
    concept;
    rentAmount;
    fee;
    feePercent;
    releasedAmount;
    iva;
    ivaPercent;
    isrRetained;
    isrPercent;
    ivaRetained;
    ivaRetainedPercent;
    releasedAmountDetailed;
    cfdiUrl;
    pdfUrl;
    constructor(data) {
        this.folio = data.folio;
        this.invoiceDate = data.invoiceDate;
        this.name = data.name;
        this.rfc = data.rfc;
        this.unitCode = data.unitCode;
        this.quantity = data.quantity;
        this.productCode = data.productCode;
        this.concept = data.concept;
        this.rentAmount = data.rentAmount;
        this.fee = data.fee;
        this.feePercent = data.feePercent;
        this.releasedAmount = data.releasedAmount;
        this.iva = data.iva;
        this.ivaPercent = data.ivaPercent;
        this.isrRetained = data.isrRetained;
        this.isrPercent = data.isrPercent;
        this.ivaRetained = data.ivaRetained;
        this.ivaRetainedPercent = data.ivaRetainedPercent;
        this.releasedAmountDetailed = data.releasedAmountDetailed;
        this.cfdiUrl = data.cfdiURL;
        this.pdfUrl = data.pdfURL;
    }
}
export default Automation;
